import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { X, Smartphone, Share } from "lucide-react";

const DISMISS_KEY = "phr_install_dismissed_v1";

function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}
function isAndroid() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}
function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator?.standalone === true;
}

export default function InstallBanner() {
  const [visible, setVisible] = useState(false);
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    if (isStandalone()) return;
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
    } catch {}
    if (isIOS()) { setPlatform("ios"); setVisible(true); }
    else if (isAndroid()) { setPlatform("android"); setVisible(true); }
  }, []);

  if (!visible) return null;

  const close = () => {
    setVisible(false);
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch {}
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-40 sm:hidden" data-testid="install-banner">
      <div className="trust-card p-4 flex items-start gap-3 shadow-lg">
        <div className="w-9 h-9 shrink-0 rounded-lg bg-[#EEF4FF] text-[#1E3A8A] grid place-items-center">
          <Smartphone className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-slate-900 text-sm">Add Powerhouse Refunds to your Home Screen</p>
          {platform === "ios" ? (
            <p className="text-xs text-slate-600 mt-1">
              Tap <Share className="inline w-3.5 h-3.5 mx-0.5 mb-0.5" /> in Safari, then <strong>"Add to Home Screen"</strong>.
            </p>
          ) : (
            <p className="text-xs text-slate-600 mt-1">
              Tap the ⋮ menu in Chrome, then <strong>"Add to Home screen"</strong>.
            </p>
          )}
        </div>
        <button onClick={close} className="text-slate-400 hover:text-slate-900" data-testid="install-banner-close" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
